module.exports = __webpack_public_path__ + "static/media/resend.2c43fdb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resend.svg
// module id = 1356
// module chunks = 0